
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import Component, { mixins } from "vue-class-component";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";
import { Prop } from "vue-property-decorator";

const truckModuleState = getModule(TruckModule);

@Component({
  components: {
    Select
  }
})
export default class FacilitySelect extends mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  items: any[] = [];

  @Prop({ default: null })
  facilityCode: string;

  @Prop({default: false})
  required: boolean;

  async created() {
    try {
      const results = await truckModuleState.getCarriers({facilityCode: this.facilityCode});

      if (results) {
        this.items = results.map(x => ({ label: x.name, value: x.id }));
      }
    } catch (ex) {
      console.error(ex);
    }
  }
}
